// @flow

import type { JSONValue } from 'common/types';

import type { Result as VariantResult } from './types/Result';
export { foldResult } from './types/Result';

import type { AjaxObject } from './jsonApiRequest';
export type { AjaxObject };

type JsonApiRequestSuccess = JSONValue;
type JsonApiRequestFailure = {|
  requestOptions: AjaxObject,
  jqXHR: {
    responseJSON?: JSONValue,
    responseText: string,
    readyState: 0 | 1 | 2 | 3 | 4,
    status: number,
    ...
  },
  errors: $ReadOnlyArray<string>
|};

export type JsonApiResult = VariantResult<
  JsonApiRequestSuccess,
  JsonApiRequestFailure
>;
